<template>
  <div>
    <div class="mt-4 mb-4">
      <form @submit.prevent="submit" @keydown="form.onKeydown($event)">
        <alert-error
          v-if="form.errors.get('message')"
          :form="form"
          :message="form.errors.get('message')"
        ></alert-error>
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body mb-n2">
                <div class="row justify-content-center">
                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="intitule"
                        >Intitulé <span class="text-danger">*</span></label
                      >
                      <input
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('intitule') }"
                        id="intitule"
                        v-model="form.intitule"
                        type="text"
                        placeholder="Intitulé"
                        maxlength="100"
                      />
                      <has-error :form="form" field="intitule"></has-error>
                    </div>
                  </div>

                  <div class="col-md-6 col-lg-2">
                    <div class="form-group">
                      <label for="duree"
                        >Durée (heures)
                        <span class="text-danger">*</span></label
                      >
                      <div class="input-group">
                        <div
                          class="input-group-prepend bg-transparent"
                          @click="
                            form.duree = form.duree - 1 > 0 ? form.duree - 1 : 1
                          "
                        >
                          <span
                            class="input-group-text bg-transprent border-right-0"
                            role="button"
                          >
                            <i class="fas fa-minus text-danger"></i>
                          </span>
                        </div>
                        <input
                          type="text"
                          class="form-control text-center"
                          :class="{
                            'is-invalid': form.errors.has('duree'),
                          }"
                          id="duree"
                          v-model.number="form.duree"
                          placeholder="Durée (heures)"
                          required
                        />
                        <div
                          class="input-group-append bg-transparent"
                          @click="form.duree++"
                        >
                          <span
                            class="input-group-text bg-transprent border-left-0"
                            role="button"
                          >
                            <i class="fas fa-plus text-success"></i>
                          </span>
                        </div>
                        <has-error :form="form" field="duree"></has-error>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6 col-lg-2">
                    <div class="form-group">
                      <label for="nbre_place"
                        >Nombre de places disponibles
                        <span class="text-danger">*</span></label
                      >
                      <div class="input-group">
                        <div
                          class="input-group-prepend bg-transparent"
                          @click="
                            form.nbre_place =
                              form.nbre_place - 1 > 0 ? form.nbre_place - 1 : 1
                          "
                        >
                          <span
                            class="input-group-text bg-transprent border-right-0"
                            role="button"
                          >
                            <i class="fas fa-minus text-danger"></i>
                          </span>
                        </div>
                        <input
                          type="text"
                          class="form-control text-center"
                          :class="{
                            'is-invalid': form.errors.has('nbre_place'),
                          }"
                          id="nbre_place"
                          v-model.number="form.nbre_place"
                          placeholder="Nombre de places disponibles"
                        />
                        <div
                          class="input-group-append bg-transparent"
                          @click="form.nbre_place++"
                        >
                          <span
                            class="input-group-text bg-transprent border-left-0"
                            role="button"
                          >
                            <i class="fas fa-plus text-success"></i>
                          </span>
                        </div>
                        <has-error :form="form" field="nbre_place"></has-error>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 col-lg-6">
            <b-card class="text-black" header-class="bg-silver">
              <template #header>
                <div>
                  <h5 class="font-size-16 mb-0">
                    <i class="fa fa-cube mr-0"></i> Les pré-requis compétence
                  </h5>
                </div>
              </template>
              <b-alert
                :show="itemPrerequisCompetenceError !== null"
                dismissible
                variant="danger"
                class="mb-4"
              >
                <span v-html="itemPrerequisCompetenceError"></span>
              </b-alert>
              <div class="row">
                <div class="row d-flex justify-content-center">
                  <div class="col-md-12 col-lg-8">
                    <div class="form-group">
                      <label for="domaine">Domaine de compétence </label>
                      <v-custom-select
                        label="nom"
                        id="domaine"
                        :options="domaines"
                        :reduce="(domaine) => domaine.uuid"
                        v-model="selectedPrerequisCompetenceDomaine"
                        placeholder="Domaine de compétence"
                      >
                        <template v-slot:option="{ nom }">
                          <h5 style="margin: 0">{{ nom }}</h5>
                        </template>
                        <template #no-options> Aucune donnée </template>
                        <template #search="{ attributes, events }">
                          <input
                            id="domaine"
                            class="custom-select-height vs__search"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      </v-custom-select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="card">
                    <div class="card-body mt-n2 mb-n2">
                      <div class="row mt-n2 d-flex justify-content-center">
                        <div class="col-md-12 col-lg-12">
                          <cool-select
                            v-model="selectedPrerequisCompetence"
                            :items="selectionablePrerequisCompetences"
                            item-text="nom"
                            placeholder="Recherche compétence"
                            @select="onSelectedPrerequisCompetence"
                            :search-text.sync="searchPrerequisCompetenceText"
                          >
                            <template #no-data>
                              {{
                                selectionablePrerequisCompetences.length
                                  ? 'Aucun resultat.'
                                  : '2 caratères pour lancer la recherche.'
                              }}
                            </template>
                            <template #item="{ item }">
                              <div class="item">
                                <div style="font-size: 1.1em">
                                  <span class="d-block">
                                    {{ item.nom }}
                                  </span>
                                </div>
                              </div>
                            </template>
                          </cool-select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <div class="row mt-n2">
                <div class="col-md-12">
                  <ul class="list-group" v-if="prerequisCompetences.length > 0">
                    <li
                      v-for="(item, index) in prerequisCompetences"
                      :key="index"
                      class="list-group-item d-flex justify-content-between align-items-center"
                    >
                      {{ item.nom }}
                      <a
                        class="cursor-pointer"
                        @click.prevent="removePrerequisCompetence(index)"
                      >
                        <i class="fa fa-trash font-size-17 text-danger"></i
                      ></a>
                    </li>
                  </ul>
                  <p
                    v-else
                    class="text-dark lead text-center"
                    style="color: black"
                  >
                    Pas de pré-requis
                  </p>
                </div>
              </div>
            </b-card>
          </div>
          <div class="col-md-12 col-lg-6">
            <b-card class="text-black" header-class="bg-silver">
              <template #header>
                <div>
                  <h5 class="font-size-16 mb-0">
                    <i class="fa fa-cube mr-0"></i> Les compétences visées
                  </h5>
                </div>
              </template>
              <b-alert
                :show="itemCompetenceError !== null"
                dismissible
                variant="danger"
                class="mb-4"
              >
                <span v-html="itemCompetenceError"></span>
              </b-alert>
              <div class="row">
                <div class="row d-flex justify-content-center">
                  <div class="col-md-12 col-lg-8">
                    <div class="form-group">
                      <label for="domaine">Domaine de compétence </label>
                      <v-custom-select
                        label="nom"
                        id="domaine"
                        :options="domaines"
                        :reduce="(domaine) => domaine.uuid"
                        v-model="selectedCompetenceDomaine"
                        placeholder="Domaine de compétence"
                      >
                        <template v-slot:option="{ nom }">
                          <h5 style="margin: 0">{{ nom }}</h5>
                        </template>
                        <template #no-options> Aucune donnée </template>
                        <template #search="{ attributes, events }">
                          <input
                            id="domaine"
                            class="custom-select-height vs__search"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      </v-custom-select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="card">
                    <div class="card-body mt-n2 mb-n2">
                      <div class="row mt-n2 d-flex justify-content-center">
                        <div class="col-md-12 col-lg-12">
                          <cool-select
                            v-model="selectedCompetence"
                            :items="selectionableCompetences"
                            item-text="nom"
                            placeholder="Recherche compétence"
                            @select="onSelectedComptence"
                            :search-text.sync="searchCompetenceText"
                          >
                            <template #no-data>
                              {{
                                selectionableCompetences.length
                                  ? 'Aucun resultat.'
                                  : '2 caratères pour lancer la recherche.'
                              }}
                            </template>
                            <template #item="{ item }">
                              <div class="item">
                                <div style="font-size: 1.1em">
                                  <span class="d-block">
                                    {{ item.nom }}
                                  </span>
                                </div>
                              </div>
                            </template>
                          </cool-select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <div class="row mt-n2">
                <div class="col-md-12">
                  <ul class="list-group" v-if="competences.length > 0">
                    <li
                      v-for="(item, index) in competences"
                      :key="index"
                      class="list-group-item d-flex justify-content-between align-items-center"
                    >
                      {{ item.nom }}
                      <a
                        class="cursor-pointer"
                        @click.prevent="removeCompetence(index)"
                      >
                        <i class="fa fa-trash font-size-17 text-danger"></i
                      ></a>
                    </li>
                  </ul>
                  <p
                    v-else
                    class="text-dark lead text-center"
                    style="color: black"
                  >
                    Pas de compétences
                  </p>
                </div>
              </div>
            </b-card>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 col-lg-6">
            <b-card class="text-black" header-class="bg-silver">
              <template #header>
                <div>
                  <h5 class="font-size-16 mb-0">
                    <i class="fa fa-cube mr-0"></i> Les pré-requis habilitation
                  </h5>
                </div>
              </template>
              <b-alert
                :show="itemPrerequisHabilitationError !== null"
                dismissible
                variant="danger"
                class="mb-4"
              >
                <span v-html="itemPrerequisHabilitationError"></span>
              </b-alert>
              <div class="row">
                <div class="col-md-12">
                  <div class="card">
                    <div class="card-body mt-n2 mb-n2">
                      <div class="row mt-n2 d-flex justify-content-center">
                        <div class="col-md-12 col-lg-12">
                          <cool-select
                            v-model="selectedPrerequisHabilitation"
                            :items="selectionablePrerequisHabilitations"
                            item-text="nom"
                            placeholder="Recherche habilitation"
                            @select="onSelectedPrerequisHabilitation"
                            :search-text.sync="searchPrerequisHabilitationText"
                          >
                            <template #no-data>
                              {{
                                selectionablePrerequisHabilitations.length
                                  ? 'Aucun resultat.'
                                  : '2 caratères pour lancer la recherche.'
                              }}
                            </template>
                            <template #item="{ item }">
                              <div class="item">
                                <div style="font-size: 1.1em">
                                  <span class="d-block">
                                    {{ item.nom }}
                                  </span>
                                </div>
                              </div>
                            </template>
                          </cool-select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <div class="row mt-n2">
                <div class="col-md-12">
                  <ul
                    class="list-group"
                    v-if="prerequisHabilitations.length > 0"
                  >
                    <li
                      v-for="(item, index) in prerequisHabilitations"
                      :key="index"
                      class="list-group-item d-flex justify-content-between align-items-center"
                    >
                      {{ item.nom }}
                      <a
                        class="cursor-pointer"
                        @click.prevent="removePrerequisHabilitation(index)"
                      >
                        <i class="fa fa-trash font-size-17 text-danger"></i
                      ></a>
                    </li>
                  </ul>
                  <p
                    v-else
                    class="text-dark lead text-center"
                    style="color: black"
                  >
                    Pas de pré-requis
                  </p>
                </div>
              </div>
            </b-card>
          </div>
          <div class="col-md-12 col-lg-6">
            <b-card class="text-black" header-class="bg-silver">
              <template #header>
                <div>
                  <h5 class="font-size-16 mb-0">
                    <i class="fa fa-cube mr-0"></i> Les habilitations visées
                  </h5>
                </div>
              </template>
              <b-alert
                :show="itemHabilitationError !== null"
                dismissible
                variant="danger"
                class="mb-4"
              >
                <span v-html="itemHabilitationError"></span>
              </b-alert>

              <div class="row">
                <div class="col-md-12">
                  <div class="card">
                    <div class="card-body mt-n2 mb-n2">
                      <div class="row mt-n2 d-flex justify-content-center">
                        <div class="col-md-12 col-lg-12">
                          <cool-select
                            v-model="selectedHabilitation"
                            :items="selectionableHabilitations"
                            item-text="nom"
                            placeholder="Recherche habilitation"
                            @select="onSelectedHabilitation"
                            :search-text.sync="searchHabilitationText"
                          >
                            <template #no-data>
                              {{
                                selectionableHabilitations.length
                                  ? 'Aucun resultat.'
                                  : '2 caratères pour lancer la recherche.'
                              }}
                            </template>
                            <template #item="{ item }">
                              <div class="item">
                                <div style="font-size: 1.1em">
                                  <span class="d-block">
                                    {{ item.nom }}
                                  </span>
                                </div>
                              </div>
                            </template>
                          </cool-select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <div class="row mt-n2">
                <div class="col-md-12">
                  <ul class="list-group" v-if="habilitations.length > 0">
                    <li
                      v-for="(item, index) in habilitations"
                      :key="index"
                      class="list-group-item d-flex justify-content-between align-items-center"
                    >
                      {{ item.nom }}
                      <a
                        class="cursor-pointer"
                        @click.prevent="removeHabilitation(index)"
                      >
                        <i class="fa fa-trash font-size-17 text-danger"></i
                      ></a>
                    </li>
                  </ul>
                  <p
                    v-else
                    class="text-dark lead text-center"
                    style="color: black"
                  >
                    Pas d'habilitations
                  </p>
                </div>
              </div>
            </b-card>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 col-lg-6">
            <div class="card">
              <div class="card-body mb-n2">
                <div class="row">
                  <div class="col-12">
                    <div class="form-group">
                      <label for="description"
                        >Description
                        <span class="text-danger">*</span>
                      </label>
                      <textarea
                        v-model="form.description"
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('description'),
                        }"
                        rows="10"
                      ></textarea>
                      <has-error :form="form" field="description"></has-error>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mb-4 mt-2">
          <div class="col-md-12 text-right">
            <ButtonLoader
              :busy="form.busy"
              type="submit"
              customClass="btn btn-custom-primary w-40"
              loadText="Traitement en cours..."
              Text="Enregistrer"
              style="min-width: 100px"
            ></ButtonLoader>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import URL from '@/http/rh/formation/formation';
import Form from 'vform';
import { mapGetters } from 'vuex';
import { mapActions } from 'vuex';
import { CoolSelect } from 'vue-cool-select';

export default {
  data() {
    return {
      form: new Form({
        intitule: '',
        duree: 1,
        nbre_place: 1,
        description: '',
      }),
      competences: [],
      prerequisCompetences: [],
      habilitations: [],
      prerequisHabilitations: [],

      selectedCompetenceDomaine: null,
      selectedCompetence: null,
      searchCompetenceText: null,

      selectedPrerequisCompetenceDomaine: null,
      selectedPrerequisCompetence: null,
      searchPrerequisCompetenceText: null,

      itemCompetenceError: null,
      itemPrerequisCompetenceError: null,

      selectedHabilitation: null,
      searchHabilitationText: null,

      selectedPrerequisHabilitation: null,
      searchPrerequisHabilitationText: null,

      itemHabilitationError: null,
      itemPrerequisHabilitationError: null,
    };
  },
  components: {
    CoolSelect,
  },
  computed: {
    ...mapGetters('formation', [
      'currentFormation',
      'domaines',
      'allHabilitations',
    ]),
    selectionableCompetences() {
      if (this.selectedCompetenceDomaine) {
        let domaine = window._.find(
          this.domaines,
          (d) => d.uuid === this.selectedCompetenceDomaine
        );

        if (domaine) {
          let currentPrerequis = this.prerequisCompetences
            .filter((s) => s.id !== null)
            .map((item) => item.id);

          return domaine.competences.filter(
            (c) => !currentPrerequis.includes(Number(c.id))
          );
        }
      }
      return [];
    },
    selectionablePrerequisCompetences() {
      if (this.selectedPrerequisCompetenceDomaine) {
        let domaine = window._.find(
          this.domaines,
          (d) => d.uuid === this.selectedPrerequisCompetenceDomaine
        );

        if (domaine) {
          let currentCompetences = this.competences
            .filter((s) => s.id !== null)
            .map((item) => item.id);

          return domaine.competences.filter(
            (c) => !currentCompetences.includes(Number(c.id))
          );
        }
      }
      return [];
    },
    selectionableHabilitations() {
      let currentPrerequis = this.prerequisHabilitations
        .filter((s) => s.id !== null)
        .map((item) => item.id);

      return this.allHabilitations.filter(
        (c) => !currentPrerequis.includes(Number(c.id))
      );
    },
    selectionablePrerequisHabilitations() {
      let currentHabilites = this.habilitations
        .filter((s) => s.id !== null)
        .map((item) => item.id);

      return this.allHabilitations.filter(
        (c) => !currentHabilites.includes(Number(c.id))
      );
    },
  },
  watch: {
    currentFormation: {
      immediate: true,
      handler() {
        this.competences = this.currentFormation.competences;
        this.prerequisCompetences = this.currentFormation.prerequis_competences;

        this.habilitations = this.currentFormation.habilitations;
        this.prerequisHabilitations =
          this.currentFormation.prerequis_habilitations;
      },
    },
  },
  methods: {
    ...mapActions('formation', [
      'setCurrentFormation',
      'setDomaine',
      'setAllHabilitation',
    ]),
    async refresh() {
      this.setDomaine([]);
      this.setAllHabilitation([]);
      this.setCurrentFormation(null);
      this.selectedCompetenceDomaine = null;
      this.selectedPrerequisCompetence = null;

      await window.axios
        .all([
          window.axios.get(URL.GET_REQUIREMENTS),
          window.axios.get(URL.FORMATION + '/' + this.$route.params.id, {
            params: {
              edit: true,
            },
          }),
        ])
        .then(
          window.axios.spread((resp1, resp2) => {
            this.setDomaine(resp1.data.domaines);
            this.setAllHabilitation(resp1.data.habilitations);
            this.setCurrentFormation(resp2.data.formation);
          })
        )
        .catch();

      await this.init();
    },
    init() {
      Object.assign(this.form, this.currentFormation);
      delete this.form.id;
      delete this.form.competences;
      delete this.form.prerequis_competences;
      delete this.form.habilitations;
      delete this.form.prerequis_habilitations;
    },

    onSelectedComptence(select) {
      if (select) {
        var objExiste = window._.find(
          this.competences,
          (o) => o.id === select.id
        );

        if (!objExiste) {
          let item = {
            id: select.id,
            uuid: select.uuid,
            nom: select.nom,
          };

          this.competences.push(item);
        }

        this.searchCompetenceText = null;
        this.selectedCompetence = null;
      }
    },
    removeCompetence(index) {
      this.competences.splice(index, 1);
    },
    onSelectedPrerequisCompetence(select) {
      if (select) {
        var objExiste = window._.find(
          this.prerequisCompetences,
          (o) => o.id === select.id
        );

        if (!objExiste) {
          let item = {
            id: select.id,
            uuid: select.uuid,
            nom: select.nom,
          };

          this.prerequisCompetences.push(item);
        }

        this.searchPrerequisCompetenceText = null;
        this.selectedPrerequisCompetence = null;
      }
    },
    removePrerequisCompetence(index) {
      this.prerequisCompetences.splice(index, 1);
    },

    onSelectedHabilitation(select) {
      if (select) {
        var objExiste = window._.find(
          this.habilitations,
          (o) => o.id === select.id
        );

        if (!objExiste) {
          let item = {
            id: select.id,
            uuid: select.uuid,
            nom: select.nom,
          };

          this.habilitations.push(item);
        }

        this.searchHabilitationText = null;
        this.selectedHabilitation = null;
      }
    },
    removeHabilitation(index) {
      this.habilitations.splice(index, 1);
    },
    onSelectedPrerequisHabilitation(select) {
      if (select) {
        var objExiste = window._.find(
          this.prerequisHabilitations,
          (o) => o.id === select.id
        );

        if (!objExiste) {
          let item = {
            id: select.id,
            uuid: select.uuid,
            nom: select.nom,
          };

          this.prerequisHabilitations.push(item);
        }

        this.searchPrerequisHabilitationText = null;
        this.selectedPrerequisHabilitation = null;
      }
    },
    removePrerequisHabilitation(index) {
      this.prerequisHabilitations.splice(index, 1);
    },

    submit() {
      this.selectedCompetenceDomaine = null;
      this.selectedPrerequisCompetence = null;

      this.itemCompetenceError = null;
      this.itemPrerequisCompetenceError = null;

      this.itemHabilitationError = null;
      this.itemPrerequisHabilitationError = null;

      this.form.competences = this.competences
        .filter((s) => s.uuid !== null)
        .map((item) => item.uuid);

      this.form.prerequis_competences = this.prerequisCompetences
        .filter((s) => s.uuid !== null)
        .map((item) => item.uuid);

      this.form.habilitations = this.habilitations
        .filter((s) => s.uuid !== null)
        .map((item) => item.uuid);

      this.form.prerequis_habilitations = this.prerequisHabilitations
        .filter((s) => s.uuid !== null)
        .map((item) => item.uuid);

      this.form
        .put(URL.FORMATION + '/' + this.$route.params.id)
        .then((resp) => {
          this.showSimpleAlerte('top-end', 'success', resp.data.message);
          this.form.reset();
          this.refresh();
        })
        .catch((err) => {
          window._.forEach(err.response.data.errors, (value, key) => {
            if (key.includes('competences')) {
              this.itemCompetenceError = value[0];
            } else if (key.includes('prerequis_competences')) {
              this.itemPrerequisCompetenceError = value[0];
            } else if (key.includes('habilitations')) {
              this.itemHabilitationError = value[0];
            } else if (key.includes('prerequis_habilitations')) {
              this.itemPrerequisHabilitationError = value[0];
            } else {
              this.form.errors.set('message', err.response.data.message);
            }
            return false;
          });
        });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
